module.exports = __webpack_public_path__ + "media/application/images/svgs/maximize-2-dd0e3e71d44c1cb9bf0010a175bb2a48.svg";